export const MIN_ROOT_CAUSE_ANALYSIS_LENGTH = 20;

export const FINDING_SEVERITIES_REQUIRING_EVIDENCE_RCA = ['major', 'minor'] as const;

export type ActionValidationMode = 'save' | 'submit';

export interface ActionEvidenceRcaValues {
  evidence?: unknown[] | null;
  rootCause?: string[] | null;
  rootCauseAnalysis?: string | null;
  findingSeverity?: string | null;
}

export interface ActionValidationError {
  title: string;
  field: 'evidence' | 'rootCause' | 'rootCauseAnalysis';
}

export const requiresEvidenceAndRcaOnSubmit = (findingSeverity?: string | null): boolean => {
  if (!findingSeverity) return false;
  return FINDING_SEVERITIES_REQUIRING_EVIDENCE_RCA.includes(
    findingSeverity.toLowerCase() as (typeof FINDING_SEVERITIES_REQUIRING_EVIDENCE_RCA)[number],
  );
};

export const getActionSubmitValidationErrors = (
  values: ActionEvidenceRcaValues,
): ActionValidationError[] => {
  if (!requiresEvidenceAndRcaOnSubmit(values.findingSeverity)) return [];

  const errors: ActionValidationError[] = [];

  if (!values.evidence || values.evidence.length === 0)
    errors.push({ title: 'Evidence is required', field: 'evidence' });

  if (!values.rootCause || values.rootCause.length === 0)
    errors.push({ title: 'Root cause is required', field: 'rootCause' });

  const rootCauseAnalysis = values.rootCauseAnalysis?.trim() || '';
  if (rootCauseAnalysis.length < MIN_ROOT_CAUSE_ANALYSIS_LENGTH) {
    errors.push({
      title: 'Root cause analysis must have minimum 20 characters',
      field: 'rootCauseAnalysis',
    });
  }

  return errors;
};

export const validateActionSubmitRequirements = (
  values: ActionEvidenceRcaValues,
  mode: ActionValidationMode,
): ActionValidationError | null => {
  if (mode !== 'submit') return null;

  const errors = getActionSubmitValidationErrors(values);
  return errors[0] ?? null;
};
